import { render, staticRenderFns } from "./office-card.vue?vue&type=template&id=b6353cd4&"
import script from "./office-card.vue?vue&type=script&lang=js&"
export * from "./office-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b6353cd4', component.options)
    } else {
      api.reload('b6353cd4', component.options)
    }
    module.hot.accept("./office-card.vue?vue&type=template&id=b6353cd4&", function () {
      api.rerender('b6353cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/custom-apps/components/location-finder/office-card.vue"
export default component.exports